import script from "./ColpoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ColpoTable.vue?vue&type=script&setup=true&lang=js"

import "./ColpoTable.vue?vue&type=style&index=0&id=8bb10fe2&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bb10fe2"]])

export default __exports__